export default __webpack_public_path__ + "static/media/pic1.b7a9e70e.jpg";